import { Toast } from "flowbite-react";
import Dashboard from "../../common/components/layout/Dashboard";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableMaintenanceCompleted from "./components/page/MaintenanceCompleted.Page";

function MaintenanceCompleted() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableMaintenanceCompleted />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}

export default MaintenanceCompleted;
